import { useEffect, useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../helpers/httpWrapper';
import { ICreateAPIKeyRequest, ICreateAPIRKeyesponse, IDeleteAPIKeyRequest, IGetAPIKeyRequest, IGetAPIKeyResponse, VCreateAPIKey, VDeleteAPIKey, VGetAPIKey } from '../../../../networked-shared-interfaces/interfaces-phase2/platform-admin/sub-routes/external-vendor';
import { URLWrapper } from '../../../../networked-shared-interfaces/url-wrapper';
import { toastService } from '../../../../services/toast.service';

export const useDeveloperSection = (communityId: string) => {
	const [apiKeyData, setApiKeyData] = useState<IGetAPIKeyResponse | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const getAPIKey = async () => {
		if (!communityId) return;

		setLoading(true);

		try {
			const response = await HttpWrapper.callUrl<IGetAPIKeyRequest, IGetAPIKeyResponse>(
				URLWrapper.urls.platformAdmin.externalVendor.getAPIKey,
				HttpMethod.GET,
				{ communityId },
				VGetAPIKey
			);
			setApiKeyData(response);
		} catch (err: any) {
			console.log("err ", err);
		} finally {
			setLoading(false);
		}
	};

	const createAPIKey = async () => {
		if (!communityId) return;

		setLoading(true);

		try {
			const response = await HttpWrapper.callUrl<ICreateAPIKeyRequest, ICreateAPIRKeyesponse>(
				URLWrapper.urls.platformAdmin.externalVendor.createAPIKey,
				HttpMethod.POST,
				{ communityId },
				VCreateAPIKey
			);

			toastService.success('API Key created successfully!');
			setApiKeyData({ apiKey: response['x-api-Key'] });
		} catch (err: any) {
			console.log("create API key error: ", err);
			toastService.error(err.message || 'Failed to create API key');
		} finally {
			setLoading(false);
		}
	};

	const deleteAPIKey = async () => {
		if (!communityId || !apiKeyData?.apiKey) return;

		const confirmDelete = window.confirm('Are you sure you want to delete this API key? This action cannot be undone.');

		if (!confirmDelete) return;

		setLoading(true);

		try {
			await HttpWrapper.callUrl<IDeleteAPIKeyRequest, {}>(
				URLWrapper.urls.platformAdmin.externalVendor.deleteAPIKey,
				HttpMethod.DELETE,
				{ communityId },
				VDeleteAPIKey
			);

			toastService.success('API Key deleted successfully!');
			setApiKeyData(null);
		} catch (err: any) {
			console.log("delete API key error: ", err);
			toastService.error(err.message || 'Failed to delete API key');
		} finally {
			setLoading(false);
		}
	};

	const copyAPIKey = () => {
		if (apiKeyData?.apiKey) {
			navigator.clipboard.writeText(apiKeyData.apiKey);
			toastService.success('API Key copied to clipboard!');
		}
	};

	useEffect(() => {
		getAPIKey();
	}, [communityId]);

	return {
		apiKeyData,
		loading,
		getAPIKey,
		createAPIKey,
		deleteAPIKey,
		copyAPIKey
	};
};
